import Axios from "axios";
import {
    SET_HRM_CLAIM_LIST,
    UNSET_HRM_CLAIM_LIST,
    SET_EDITING_HRM_CLAIM,
    UNSET_EDITING_HRM_CLAIM,
} from "@/store/mutation-types";
import {
    getClaimList,
    getClaimById,
    saveUpdateClaim,
    deleteClaim,
    deleteClaimAttachment,
    disburseClaim

} from "@/store/api";

// initial state
const state = {
    getHrmClaimList: [],
    getEditingHrmClaim: null,
};

const getters = {
    getEditingHrmClaim(state) {
        return state.getEditingHrmClaim;
    },
    getHrmClaimList(state) {
        return state.getHrmClaimList;
    },
};

const mutations = {
    [SET_HRM_CLAIM_LIST](state, data) {
        state.getHrmClaimList = data;
    },
    [UNSET_HRM_CLAIM_LIST](state) {
        state.getHrmClaimList = [];
    },
    [SET_EDITING_HRM_CLAIM](state, data) {
        state.getEditingHrmClaim = data;
    },
    [UNSET_EDITING_HRM_CLAIM](state) {
        state.getEditingHrmClaim = null;
    },
};

const actions = {
    getClaimList({ commit }, params) {
        return new Promise((resolve, reject) => {
            Axios.post(getClaimList, params || {})
                .then(function (response) {
                    commit('SET_HRM_CLAIM_LIST', response.data.data || [])
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_HRM_CLAIM_LIST')
                    reject(error);
                });
        });
    },


    getClaimById({ commit }, id) {
        return new Promise((resolve, reject) => {
            Axios.get(getClaimById(id))
                .then(function (response) {
                    commit('SET_EDITING_HRM_CLAIM', response.data.data || null)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_EDITING_HRM_CLAIM')
                    reject(error);
                });
        });
    },

    saveUpdateClaim({ commit }, data) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING",{color: 'primary'})
            Axios.post(saveUpdateClaim, data)
                .then(function (response) {
                    resolve(response.data);
                    commit("UNSET_LOADING")
                })
                .catch(function (error) {
                    reject(error);
                    commit("UNSET_LOADING")
                });
        });
    },

    deleteClaim({ commit }, id) {
        return new Promise((resolve, reject) => {
            Axios.delete(deleteClaim(id))
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },

    deleteClaimAttachment({ commit }, id) {
        return new Promise((resolve, reject) => {
            Axios.delete(deleteClaimAttachment(id))
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },

    disburseClaim({ commit }, {data, id}) {
        const disburseClaimApi = disburseClaim.replace('{id}', id)
        return new Promise((resolve, reject) => {
            commit("SET_LOADING",{color: 'primary'})
            Axios.post(disburseClaimApi, data)
                .then(function (response) {
                    resolve(response.data);
                    commit("UNSET_LOADING")
                })
                .catch(function (error) {
                    reject(error);
                    commit("UNSET_LOADING")
                });
        });
    },


};

export default {
    state,
    getters,
    actions,
    mutations,
};